import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_baggage_per_person",
  stages: {
    main: 1, //  2+ travellers with branded fares including baggage (SR, BF, BF upsell modal, check + pay, post booking)
    search_results: 2,
    bf_page: 3,
    sees_upsell_modal: 4,
    check_pay_modal: 5,
    post_book: 6,
    infant_traveller: 7,
    ddot: 8,
    mdot: 9
  },
  goals: {
    close_upsell_modal: 1,
    pax_back_ddot: 2,
    extras_back_mdot: 3,
    click_price_info: 4
  },
  defaultStage: 1
});

export const trackStages = (
  isMobile: boolean,
  hasInfant: boolean,
  isSearchResults: boolean,
  isBrandedFarePage: boolean,
  isCheckAndPay: boolean,
  isPostBooking: boolean
) => {
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (hasInfant) utils.stages.infant_traveller();
  if (isSearchResults) utils.stages.search_results();
  if (isBrandedFarePage) utils.stages.bf_page();
  if (isCheckAndPay) utils.stages.check_pay_modal();
  if (isPostBooking) utils.stages.post_book();
};

export default { trackStages, ...utils };
